// Event Images API client. Gracefully degrades when backend is not configured.

import { authFetch, getAuthToken } from "./authFetch";

const BASE_URL =
  process.env.REACT_APP_EVENT_IMAGES_API_URL ||
  "https://7vnhfarqxg.execute-api.us-east-1.amazonaws.com/prod";

let warnedNotConfigured = false;
const warnNotConfiguredOnce = () => {
  if (!warnedNotConfigured) {
    // eslint-disable-next-line no-console
    console.info(
      "Event Images API not configured; falling back to legacy options only."
    );
    warnedNotConfigured = true;
  }
};

const jsonHeaders = () => ({ "Content-Type": "application/json" });

export const fetchEventImages = async ({ activity } = {}) => {
  if (!BASE_URL || !getAuthToken()) {
    warnNotConfiguredOnce();
    return { items: [] };
  }

  const url = new URL(`${BASE_URL.replace(/\/$/, "")}/event-images`);
  if (activity) {
    url.searchParams.set("activity", activity);
  }

  const response = await authFetch(url.toString(), {
    method: "GET",
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch event images: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();
  return {
    items: Array.isArray(data?.items) ? data.items : [],
  };
};

export const fetchEventImageActivities = async () => {
  if (!BASE_URL || !getAuthToken()) {
    warnNotConfiguredOnce();
    return { activities: [] };
  }

  const url = `${BASE_URL.replace(/\/$/, "")}/event-images/activities`;
  const response = await authFetch(url, {
    method: "GET",
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch event image activities: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();
  return {
    activities: Array.isArray(data?.activities) ? data.activities : [],
  };
};
